import { DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PAGELENGTH } from 'src/app/endpoints';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { CategoryService } from 'src/app/shared/service/category/category.service';
import { SampleService } from 'src/app/shared/service/sample/sample.service';
import { UserServiceService } from 'src/app/shared/service/userService/user-service.service';
declare var bootstrap: any;

@Component({
  selector: 'app-sample-distributed-by-distributors',
  imports: [
    CardComponent,
    MatTableModule,
    MatPaginatorModule,
    NgToggleModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatTabsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    MatLabel,
    MatInputModule,
    DatePipe,
    RouterLink
  ],
  templateUrl: './sample-distributed-by-distributors.component.html',
  styleUrl: './sample-distributed-by-distributors.component.scss'
})
export class SampleDistributedByDistributorsComponent {

  sampleDistributionModal: any;
  startpoint: number = 0;
  totalLoaded: number = 0;
  total: number = 0;
  pageNo: number = 0;
  distributorId: any;
  distributorType: any;
  singleDistributor: any;
  issuerDistributorId: any;
  sampleId: any;
  sid: any;
  pageSize: number = 10;

  issuedSamplesToDistributorsDataSource = new MatTableDataSource<any>([]);

  issuedSamplesToDistributorsDisplayedColumns: string[] = [
    'srno', 'name', 'email', 'phone', 'cityState', 'quantityAssigned', 'quantityRemaining', 'distributorLimit', 'issuedOn'
  ];

  issuedSamplesToCustomersDisplayedColumns: string[] = [
    'srno', 'name', 'gender', 'dob', 'state', 'city', 'address', 'issuedQuantity'
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  // Constructor
  constructor(
    private userService: UserServiceService,
    private categoryService: CategoryService,
    private sampleService: SampleService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute
  ) { }



  selectedRecipientType: any = 'Retailer';

  onRecipientChange(value: any) {
    this.selectedRecipientType = value;
    this.issuedSamplesToDistributors(null);
  }


  ngOnInit(): void {
    this.sampleId = this.activatedRoute.snapshot.paramMap.get("sampleId");
    this.distributorId = this.activatedRoute.snapshot.paramMap.get("distributorId");
    this.distributorType = this.activatedRoute.snapshot.paramMap.get("distributorType");
    this.issuedSamplesToDistributors(null)
    this.getSingleDistributor();
    this.singleSample();
    if (this.distributorType == 2) {
      this.selectedRecipientType = 'Customer';
    }
  }
  ngAfterViewInit() {
    const modalElement = document.getElementById('sampleDistributionModal');
    if (modalElement) {
      this.sampleDistributionModal = new bootstrap.Modal(modalElement);
    }
  }



  getSingleDistributor(): void {
    if (!this.distributorId) return;
    this.spinner.show();
    this.userService.singleDistributor({ _id: this.distributorId }).subscribe({
      next: (res: any) => {
        if (res.success) this.singleDistributor = res.data;
      },
      error: (e) => this.toastr.error(e.message, 'Error'),
      complete: () => this.spinner.hide()
    });
  }

  sampleData: any

  singleSample(): void {
    if (!this.distributorId) return;
    this.spinner.show();
    this.sampleService.singleSample({ _id: this.sampleId }).subscribe({
      next: (res: any) => {
        if (res.success) this.sampleData = res.data;
      },
      error: (e) => this.toastr.error(e.message, 'Error'),
      complete: () => this.spinner.hide()
    });
  }

  calculateAge(dob: string | Date): number {
    if (!dob) return 0;
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) age--;
    return age;
  }



  debounceNameTimer: any = null;
  debounceBarCodeTimer: any = null;

  sampleSearch: any = {
    cityState: '',
    startdate: null,
    enddate: null,
  };

  onCityStateInputChange(event: any): void {
    clearTimeout(this.debounceNameTimer);
    this.debounceNameTimer = setTimeout(() => {
      const cityState = event.target.value.trim();
      this.sampleSearch.cityState = cityState || undefined;
      this.issuedSamplesToDistributors(null);
    }, 300);
  }

  onBarCodeInputChange(event: any): void {
    clearTimeout(this.debounceBarCodeTimer);
    this.debounceBarCodeTimer = setTimeout(() => {
      const code = event.target.value.trim();
      this.sampleSearch.barCode = code || undefined;
      this.issuedSamplesToDistributors(null);
    }, 300);
  }

  clearDateRange(): void {
    this.sampleSearch.startdate = null;
    this.sampleSearch.enddate = null;
    this.issuedSamplesToDistributors(null);
  }

  sampleFilter(event: any): void {
    this.issuedSamplesToDistributors(null);
  }



  issuedSamplesToDistributors(event: any): void {
    if (event === null || !event) {
      this.pageNo = 0;
      this.startpoint = 0;
      this.pageSize = this.pageSize || PAGELENGTH;
      this.issuedSamplesToDistributorsDataSource.data = [];
      this.totalLoaded = 0;
    }

    // Handle page size change
    if (event?.pageSize && event.pageSize !== this.pageSize) {
      this.pageSize = event.pageSize;
      this.pageNo = 0;
      this.startpoint = 0;
      this.issuedSamplesToDistributorsDataSource.data = [];
      this.totalLoaded = 0;
    }

    // Handle page index change
    if (event?.pageIndex !== undefined) {
      this.pageNo = event.pageIndex;
      this.startpoint = this.pageNo * (this.pageSize || PAGELENGTH);
    }

    const data: any = {
      startpoint: this.startpoint,
      limit: this.pageSize || PAGELENGTH,
      sampleId: this.sampleId,
      startdate: this.sampleSearch.startdate || undefined,
      enddate: this.sampleSearch.enddate || undefined
    };

    if (this.sampleSearch.cityState) {
      data.cityState = this.sampleSearch.cityState;
    }

    let apiCall: any;

    if (this.selectedRecipientType === 'Wholesaler') {
      apiCall = this.sampleService.allIssuedSamplesDistributorTransaction({
        ...data,
        issuerDistributorId: this.distributorId,
        receiverType: 1,
        sortByDistributorThenDate:true
      });
    } else if (this.selectedRecipientType === 'Retailer') {
      apiCall = this.sampleService.allIssuedSamplesDistributorTransaction({
        ...data,
        issuerDistributorId: this.distributorId,
        receiverType: 2,
        sortByDistributorThenDate:true
      });
    } else if (this.selectedRecipientType === 'Customer') {
      apiCall = this.sampleService.allIssuedSamplesToCustomer({
        ...data,
        issuedByDistributorId: this.distributorId
      });
    } else {
      this.toastr.error('Invalid recipient type');
      return;
    }

    this.spinner.show();
    apiCall.subscribe({
      next: (res: any) => {
        if (res.success) {
          this.total = res.total ?? 0;
          this.issuedSamplesToDistributorsDataSource.data = res.data || [];
          this.totalLoaded = this.issuedSamplesToDistributorsDataSource.data.length;

          setTimeout(() => {
            if (this.paginator) {
              this.paginator.pageIndex = this.pageNo;
              this.paginator.length = this.total;
              this.paginator.pageSize = this.pageSize ?? PAGELENGTH;
            }
          }, 0);
        }
      },
      error: (e) => {
        this.toastr.error(e?.message || 'Failed to load issued samples');
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }





}
